export enum CookieNames {
    AuthToken = 'Authorization',
    ProjectToken = 'Project-Token',
    Language = 'Language',
    Sid = 'Sid',
    GeoMessageWarned = 'GeoWarned',
    Device = 'x-device-by',
    ContentType = 'Content-Type',
    Accept = 'Accept',
    // Adding by server when auth goes by number
    PHPSession = 'PHPSESSID',
    PP_STATE = 'pp-state',
    PP_DATE = 'pp-date',
}

export enum CookieStateValues {
    accepted = '1',
    rejected = '0',
}

export enum Links {
    StoreGoogle = 'https://play.google.com/store/apps/details?id=by.mts.dating',
    StoreHuawei = 'https://appgallery.huawei.com/#/app/C101709067',
}

export enum VK {
    state = 'state=VK',
    authLink = 'https://oauth.vk.com/authorize',
    apiLink = 'https://api.vk.com/method/users.get',
    reqFields = 'first_name,photo_max_orig,city,sex,bdate',
    appID = '51612088',
    apiVersion = '5.131',
}

export enum OK {
    state = 'state=OK',
    authLink = 'https://connect.ok.ru/oauth/authorize',
    apiLink = 'https://api.ok.ru/api/users/getCurrentUser',
    reqFields = 'birthday,first_name,gender,pic_full,location',
    appKey = 'CGLCFCLGDIHBABABA',
    appID = '512001921461',
}

export enum UserStatus {
    Authorized = 'Authorized',
    Guest = 'Guest',
}

export enum Language {
    Ru = 'ru',
    Be = 'be',
    Default = 'ru',
}

export enum GalleryImg {
    minSize = 51200,
    maxSize = 10485760,
    formats = 'jpg/jpeg/png',
}

export enum MessageImg {
    minSize = 0,
    maxSize = 10485760,
    formats = 'jpg/jpeg/png',
}

export enum MessageVoice {
    maxSize = 10485760,
    maxDuration = 300000,
}

export enum TextLength {
    chat = 1000,
    bio = 80,
    feedback = 200,
    name = 16,
}

export enum Defaults {
    birthday = '1991-09-11',
    ModeratorId = 0,
}

export const BlockingErrorStatuses = [401, 402, 403, 409, 429];

export const LP_STATUS_4 = '4'; // Blacklist error
export const LP_STATUS_12 = '12'; // Subscribe error

export const VAPID_KEY = 'BMvdZzI_LvZD-o4anXPKDB07V6yPyEmWEJTORlM8DZtnuuyj2SnHyU329DSPZgw95kX7J2b4dCpBn-3gHWZSAZ0';

export const FIREBASE_CONFIG = {
    apiKey: 'AIzaSyC_HT99eEEO2Mu1Fcfz4md8Ggi9ZcmK2xU',
    authDomain: 'datingrb.firebaseapp.com',
    databaseURL: 'https://datingrb.firebaseio.com',
    projectId: 'datingrb',
    storageBucket: 'datingrb.appspot.com',
    messagingSenderId: '188979706604',
    appId: '1:188979706604:web:5971eecd815a819f7b43c9',
    measurementId: 'G-E1FDGQXCGV',
};

export const MINSK_CITY_GEO:[number, number] = [53.902296, 27.561862];

export const SEARCH_PARAM = 'hobby';

export const TEST_BANNER_INTERVALS = [10, 50];

export const HOURS_TO_REJECT = 48;
export const MS_IN_HOUR = 1000 * 60 * 60;
